import React from "react";
import "./Preloader.css";

const Preloader = () => {
  return (
    <div className="law-preloader">
      <div className="scales-icon">
        ⚖️
      </div>
      <h1 className="preloader-text">Justice is Loading...</h1>
    </div>
  );
};

export default Preloader;
